import { Tab, Tabs } from "@mui/material";
import React from "react";
import CustomtabsType from "./custom-tabs.type";
import { CustomTabsStyled } from "./custom-tabs.style";

const CustomTabs = (props) => {
  const { activeTab, handleChange, tabsList } = props;

  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };
  return (
    <CustomTabsStyled>
      <Tabs
        value={tabsList?.findIndex((x) => x?.value === activeTab)}
        onChange={(e, index) => {
          console.log("index", index);
          handleChange(tabsList[index]?.value);
        }}
        TabIndicatorProps={{ style: { display: "none" } }}
        indicatorColor="secondary"
        textColor="inherit"
        variant="fullWidth"
        aria-label="full width tabs example"
      >
        {tabsList?.map((option) => {
          return <Tab label={option?.label} {...a11yProps(0)} />;
        })}
      </Tabs>
    </CustomTabsStyled>
  );
};

CustomTabs.propTypes = CustomtabsType;
export default CustomTabs;
